"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImpressions = exports.getInteractorsInfo = exports.createImpression = exports.updateImpression = exports.deleteImpression = exports.getImpressionsCount = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getImpressionsCount(_a) {
    var where = _a.where;
    var variables = {
        where: where,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query($where: ImpressionWhereInput) {\n        impressionsConnection(where: $where) {\n          _count {\n            listingId\n          }\n        }\n      }\n    "], ["\n      query($where: ImpressionWhereInput) {\n        impressionsConnection(where: $where) {\n          _count {\n            listingId\n          }\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getImpressionsCount = getImpressionsCount;
function deleteImpression(_a) {
    var listingId = _a.listingId, userId = _a.userId, type = _a.type;
    var variables = {
        where: {
            listingId_userId_type: {
                listingId: listingId,
                userId: userId,
                type: type,
            },
        },
    };
    return {
        mutation: (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      mutation($where: ImpressionCustomWhereUniqueInput!) {\n        deleteImpression(where: $where) {\n          listingId\n        }\n      }\n    "], ["\n      mutation($where: ImpressionCustomWhereUniqueInput!) {\n        deleteImpression(where: $where) {\n          listingId\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.deleteImpression = deleteImpression;
function updateImpression(_a) {
    var listingId = _a.listingId, userId = _a.userId, type = _a.type, data = _a.data;
    var variables = {
        where: {
            listingId_userId_type: {
                listingId: listingId,
                userId: userId,
                type: type,
            },
        },
        data: data,
    };
    return {
        mutation: (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      mutation(\n        $where: ImpressionWhereUniqueInput!\n        $data: ImpressionUpdateInput!\n      ) {\n        updateImpression(where: $where, data: $data) {\n          userId\n          listingId\n          type\n        }\n      }\n    "], ["\n      mutation(\n        $where: ImpressionWhereUniqueInput!\n        $data: ImpressionUpdateInput!\n      ) {\n        updateImpression(where: $where, data: $data) {\n          userId\n          listingId\n          type\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.updateImpression = updateImpression;
function createImpression(_a) {
    var data = _a.data;
    var variables = {
        data: data,
    };
    return {
        mutation: (0, graphql_tag_1.default)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      mutation($data: ImpressionCreateCustomInput!) {\n        createImpression(data: $data) {\n          listingId\n        }\n      }\n    "], ["\n      mutation($data: ImpressionCreateCustomInput!) {\n        createImpression(data: $data) {\n          listingId\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.createImpression = createImpression;
function getInteractorsInfo(_a) {
    var where = _a.where, take = _a.take, skip = _a.skip;
    var variables = {
        where: tslib_1.__assign({ user: {
                is: {
                    status: {
                        equals: 'ACTIVE',
                    },
                },
            } }, where),
        take: take,
        skip: skip,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      query($where: ImpressionWhereInput, $take: Int, $skip: Int) {\n        impressions(where: $where, take: $take, skip: $skip) {\n          userId\n          listingId\n          type\n          createdAt\n          connected\n          counter\n          listing {\n            s3Prefix\n          }\n          user {\n            name\n            phone\n            whatsApp\n            status\n          }\n        }\n      }\n    "], ["\n      query($where: ImpressionWhereInput, $take: Int, $skip: Int) {\n        impressions(where: $where, take: $take, skip: $skip) {\n          userId\n          listingId\n          type\n          createdAt\n          connected\n          counter\n          listing {\n            s3Prefix\n          }\n          user {\n            name\n            phone\n            whatsApp\n            status\n          }\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getInteractorsInfo = getInteractorsInfo;
function getImpressions(_a) {
    var where = _a.where;
    var variables = {
        where: where,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      query($where: ImpressionWhereInput) {\n        impressions(where: $where) {\n          listingId\n          userId\n          type\n        }\n      }\n    "], ["\n      query($where: ImpressionWhereInput) {\n        impressions(where: $where) {\n          listingId\n          userId\n          type\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getImpressions = getImpressions;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
